var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09727 10.4916C6.65893 9.9299 7.56957 9.9299 8.13123 10.4916L15.7436 18.1039L23.356 10.4916C23.9176 9.9299 24.8283 9.9299 25.3899 10.4916C25.9516 11.0532 25.9516 11.9639 25.3899 12.5255L16.7606 21.1549C16.1989 21.7165 15.2883 21.7165 14.7266 21.1549L6.09727 12.5255C5.53561 11.9639 5.53561 11.0532 6.09727 10.4916Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.904e600fb8413459b894f77dae1a91cf.svg";
export { ForwardRef as ReactComponent };